// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_usage_model from "./web_usage_model.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

const numbers = new (Intl.NumberFormat)("en-US", {
    maximumSignificantDigits: 21,
    useGrouping: false
  });

function amount(value) {
  return "USD " + numbers.format(value / 1000000);
}

function title(value) {
  switch (value) {
    case "compute" :
      return "Sandbox compute";
    case "model" :
      return "Model";
    case "proxy" :
      return "Proxy";
    case "snapshot" :
      return "Snapshots";
    default:
      return value;
  }
}

function unit_label(value) {
  switch (value) {
    case "cached_input_tokens" :
      return "Cached input tokens";
    case "errors" :
      return "Errors";
    case "input_tokens" :
      return "Input tokens";
    case "machine_seconds" :
      return "Machine seconds";
    case "output_tokens" :
      return "Output tokens";
    case "requests" :
      return "Requests";
    case "seconds" :
      return "Seconds";
    case "turn_cached_input_tokens" :
      return "Turn cached input tokens (observed)";
    case "turn_input_tokens" :
      return "Turn input tokens (observed)";
    case "turn_output_tokens" :
      return "Turn output tokens (observed)";
    default:
      return value;
  }
}

function amount_label(category) {
  const match = category.amount_status;
  const match$1 = category.amount;
  const match$2 = category.recorded_amount;
  switch (match) {
    case /* Recorded */ 0 :
      if (match$1 !== undefined) {
        return "Reported amount: " + amount(match$1);
      } else {
        return "Price not reported";
      }
    case /* Pending */ 1 :
    case /* Unavailable */ 2 :
      break;
  }
  if (match$2 !== undefined) {
    return "Reported subtotal: " + (amount(match$2) + "; full cost unavailable");
  } else {
    return "Price not reported";
  }
}

function quantity(q) {
  return unit_label(q.unit) + (": " + numbers.format(q.value));
}

function category_view(category) {
  const partial_arg = title(category.name);
  const partial_arg$1 = 3;
  const match = category.status;
  let tmp;
  switch (match) {
    case /* Recorded */ 0 :
      tmp = /* [] */ 0;
      break;
    case /* Pending */ 1 :
      const partial_arg$2 = "Usage collection pending";
      const partial_arg$3 = "muted";
      tmp = {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: /* [] */ 0
      };
      break;
    case /* Unavailable */ 2 :
      const partial_arg$4 = "Usage unavailable";
      const partial_arg$5 = "muted";
      tmp = {
        hd: (function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        }),
        tl: /* [] */ 0
      };
      break;
  }
  const partial_arg$6 = amount_label(category);
  const partial_arg$7 = Stdlib.$at({
    hd: (function (param, param$1) {
      return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: tmp
  }, Stdlib.$at(Stdlib__List.filter_map((function (q) {
    if (q.unit === "charge") {
      return;
    }
    const partial_arg = quantity(q);
    return (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    });
  }), category.quantities), {
    hd: (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  }));
  const partial_arg$8 = {
    hd: [
      "data-usage-category",
      category.name
    ],
    tl: /* [] */ 0
  };
  const partial_arg$9 = "form-card";
  const partial_arg$10 = 0;
  const partial_arg$11 = 16;
  const partial_arg$12 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, param, param$1);
  };
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return Stdlib__Option.value(m.usage_form, Mapre_web__Web_usage_model.initial);
  }), model);
  const partial_arg = "Workspace usage";
  const partial_arg$1 = 2;
  const partial_arg$2 = "Loading usage...";
  const partial_arg$3 = "muted";
  const partial_arg$4 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg$5 = Signal.map((function (p) {
    return p.loading;
  }), source);
  const partial_arg$6 = Signal.map((function (p) {
    return p.message !== "";
  }), source);
  const partial_arg$7 = Signal.map((function (p) {
    return p.report;
  }), source);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.if_(partial_arg$6, (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___001_) {
            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (p) {
              return p.message;
            }), source)));
            const partial_arg$1 = "notice";
            return function (param, param$1) {
              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }), param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.dyn(undefined, (function (report) {
            if (report !== undefined) {
              const partial_arg = "Last " + (String(report.window_days) + " days");
              const partial_arg$1 = Stdlib__Option.fold("Final total unavailable", (function (value) {
                return "Recorded total: " + amount(value);
              }), report.total);
              const partial_arg$2 = "Reported quantities and prices only. Provider prices may differ from a settled bill. Missing evidence is not zero; turn observations are not added to request totals.";
              const partial_arg$3 = "muted";
              const partial_arg$4 = Stdlib__Option.fold("No workspace subscription configured.", (function (value) {
                return "Workspace subscription: " + value;
              }), report.subscription);
              const partial_arg$5 = "Seats used: " + (String(report.seats_used) + Stdlib__Option.fold("; no configured limit", (function (n) {
                return " of " + numbers.format(n);
              }), report.seats_limit));
              const partial_arg$6 = "Collection: " + (String(report.pending) + (" pending, " + (String(report.unattributed) + (" unattributed, " + (String(report.exhausted) + " exhausted")))));
              const partial_arg$7 = Stdlib.$at({
                hd: (function (param, param$1) {
                  return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                }),
                tl: {
                  hd: (function (param, param$1) {
                    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  }),
                  tl: {
                    hd: (function (param, param$1) {
                      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                    }),
                    tl: {
                      hd: (function (param, param$1) {
                        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                      }),
                      tl: {
                        hd: (function (param, param$1) {
                          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                        }),
                        tl: {
                          hd: (function (param, param$1) {
                            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                          }),
                          tl: /* [] */ 0
                        }
                      }
                    }
                  }
                }
              }, Stdlib__List.map(category_view, report.categories));
              const partial_arg$8 = 0;
              const partial_arg$9 = 12;
              return function (param, param$1) {
                return Lui_elements.column(undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, param, param$1);
              };
            } else {
              return function (param, param$1) {
                return Lui_elements.column(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }
          }), partial_arg$7, param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___002_) {
              const partial_arg = {
                TAG: /* Usage */ 38,
                _0: /* Refresh */ 2
              };
              const partial_arg$1 = (function (param) {
                return Lui_elements.press(send, partial_arg, param);
              });
              const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
                return p.loading;
              }), source)));
              const partial_arg$3 = "outline";
              const partial_arg$4 = "Refresh usage";
              return function (param, param$1) {
                return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }),
          tl: /* [] */ 0
        }
      }
    }
  };
  const partial_arg$8 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$9 = "usage-view";
  const partial_arg$10 = 0;
  const partial_arg$11 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, param, param$1);
  };
}

export {
  view,
  amount,
  quantity,
  category_view,
}
/* numbers Not a pure module */
